import { createContext } from 'react'

const VideoContext = createContext<any>(null)

export default VideoContext
